import { Link, RegistrationLayout, StyledBreadcrumbs } from "@/components";
import { getRegisterTranslationKey } from '@/hooks';
import { ResponsiveContainer } from "@/styles";
import { ArrowForward } from '@mui/icons-material';
import { Button, Grid, Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { NextPage } from "next";
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import type { ReactElement } from 'react';
import PageMetaHead from "src/logic/config/meta/PageMetaHead";
import useSetHeaderData from "src/logic/hooks/use-header";
import { sm } from "src/site-map";

export async function getStaticProps({ locale }) {
    return {
        props: {
            ...(await serverSideTranslations(locale)),
        },
    };
}

const page: NextPage = ({ }) => {
    const isMobile = useMediaQuery(t => t.breakpoints.down('md'));
    const { t } = useTranslation()
    useSetHeaderData('', null)
    return (
        <Grid container>
            <Grid component={ResponsiveContainer} item xs={12}>
                <StyledBreadcrumbs alias={sm.register.index.url}/>
            </Grid>
            <Grid
                container
                item
                component={ResponsiveContainer}
                xs={12}
                lg={6}
                sx={{
                    py: [6, 20]
                }}>
                <Grid container item>
                    <Typography variant="h1" sx={{ fontWeight: 'bolder' }}>  {t(getRegisterTranslationKey('headers.register_as_buyer'))} </Typography>
                </Grid>
                <Grid container item sx={{ py: 2 }}>
                    <Typography variant="body2" color="text.third"> {t(getRegisterTranslationKey('paragraphs.register_as_buyer'))} </Typography>
                </Grid>
                <Grid container item>
                    <Button
                        component={Link}
                        href={{ pathname: sm.register.asBuyer.index.url }}
                        variant='contained'
                        sx={{
                            fontSize: isMobile ? '16px' : '14px',
                            width: isMobile ? '100%' : 'initial',
                            alignContent: isMobile ? 'space-between' : 'initial',
                            flexFlow: isMobile ? 'column wrap' : 'initial'
                        }}
                        endIcon={<ArrowForward />}
                    >{t('buttons.register_as_buyer')}</Button>
                </Grid>
            </Grid>
            <Grid
                container
                item
                component={ResponsiveContainer}
                xs={12}
                lg={6}
                sx={{
                    py: [6, 20],
                    px: [3, 6],
                    backgroundColor: 'background.secondary.main',
                    backgroundImage: 'url(/assets/images/home/points.svg)'
                }}>
                <Grid container item>
                    <Typography variant="h1" sx={{ fontWeight: 'bolder' }}> {t(getRegisterTranslationKey('headers.register_as_seller'))}</Typography>
                </Grid>
                <Grid container item sx={{ py: 2 }}>
                    <Typography variant="body2" color="text.third"> {t(getRegisterTranslationKey('paragraphs.register_as_seller'))}</Typography>
                </Grid>
                <Grid container item>
                    <Button
                        component={Link}
                        href={{ pathname: sm.register.asSeller.index.url }}
                        variant='contained'
                        sx={{
                            fontSize: isMobile ? '16px' : '14px',
                            width: isMobile ? '100%' : 'initial',
                            alignContent: isMobile ? 'space-between' : 'initial',
                            flexFlow: isMobile ? 'column wrap' : 'initial'
                        }}
                        color="secondary"
                        endIcon={<ArrowForward />}
                    >{t('buttons.register_as_seller')}</Button>
                </Grid>
            </Grid>
        </Grid>
    )
}

page.getLayout = function getLayout(page: ReactElement) {
  return (
    <RegistrationLayout>
      <PageMetaHead
        page_meta={{
          title: 'Join eProcurement | Smart Procurement for Buyers and Suppliers',
          description:
            'Join the eProcurement platform to connect with trusted buyers and sellers. Register to access AI-powered tendering, sourcing, and supplier tools.',
        }}
        useExactTitle
      />
      {page}
    </RegistrationLayout>
  );
};

export default page